export default "/_next/static/images/img3-38dc26a34288c489aa51b36c801a38f5.png";